import React, { FC } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Button, Row, Col } from "antd";
import {
  HeaderPanel
} from "../../components/Dashboard";
import {
  EditPaymentModal
} from "../../components/Modals";
import "./index.scss";

const Payment: FC<{ socket: ISocket}> = ({socket}) => {
  return (
    <div className="main-layout payment-layout">
      <HeaderPanel socket={socket} dashboard={true} />
      <EditPaymentModal socket={socket} onClose={()=>{}} disableClose={true}  />
    </div>
  );
};

export default Payment;
